import {
  Brand,
  LanguageCodeType,
  useConfig,
} from '@sbercloud/uikit-product-utils';
import { ReactNode } from 'react';

import { getInitialTheme } from './utils/theme';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = getInitialTheme().theme;
  const brand = theme.includes('Dark') ? Brand.SiteDark : Brand.Site;

  useConfig({ theme, languageCode: LanguageCodeType.ruRU, brand });

  return children;
}
